export default __webpack_public_path__ + "static/media/homme_perdu.da6c8611.png";